export const ACCOUNTS_RESEARCH_TRANSACTIONS_CONTAINER_TAG_NAME =
    'accounts-research-transactions-container';
